import React from 'react';
import FourOFour from '../components/404';
function FourOFourView() {
  return <FourOFour />;
}
export default FourOFourView;
